import { render, staticRenderFns } from "./OpmerkingInvoer.vue?vue&type=template&id=134846a4"
import script from "./OpmerkingInvoer.vue?vue&type=script&lang=js"
export * from "./OpmerkingInvoer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports